import { cn } from 'src/utils/cn';
import Loader from './Loader';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  readonly children?: React.ReactNode;
  readonly variant?: 'contained' | 'text' | 'cell' | 'outline' | 'link';
  readonly isLoading?: boolean;
  readonly icon?: React.ReactNode;
}

const base =
  'inline-flex items-center justify-center py-2 px-4 font-medium cursor-pointer disabled:opacity-50 disabled:cursor-default relative overflow-hidden';
const contained = cn(
  base,
  'rounded-md text-sm transition-colors shadow-sm min-w-8 bg-azure-radiance hover:bg-curious-blue text-white whitespace-nowrap disabled:cursor-not-allowed',
);
const text = cn(
  base,
  'text-blue-500 hover:text-blue-700 disabled:text-Informational-Text text-sm font-medium gap-x-3 rounded-md py-2 px-3 text-sm/6 font-semibold hover:bg-blue-100 hover:text-Blue-text hover:shadow-inner',
);
const cell = cn(contained, 'rounded-md py-1 px-2 text-xs');
const outline = cn(
  base,
  'rounded-md text-sm transition-colors min-w-8 border border-gray-300 text-blue-600 bg-white hover:bg-blue-50 hover:border-blue-400 disabled:cursor-not-allowed',
);
const link = cn(
  'cursor-pointer text-sm text-blue-600 underline hover:text-blue-800 disabled:opacity-50 disabled:cursor-default',
);

const variantClassNames = {
  contained: contained,
  text: text,
  cell: cell,
  outline: outline,
  link: link,
};

const Button = ({
  children,
  variant = 'contained',
  className,
  icon,
  isLoading,
  ...props
}: ButtonProps) => {
  return (
    <button
      {...props}
      className={cn(variantClassNames[variant], icon && 'gap-2', className)}
    >
      {icon}
      {children}
      {isLoading ? (
        <div className="absolute pointer-events-none z-10 inset-0 flex items-center justify-center bg-black/50">
          <Loader className="w-4 h-4" />
        </div>
      ) : null}
    </button>
  );
};

export default Button;
